// Curated prebuilt Gemini TTS voices offered in the admin + per-user pickers.
// Keep in sync with GEMINI_VOICES in services/api/routers/tts.py (the backend
// validates against that set and falls back to the default for unknown values).
// "Iapetus" is the default voice.
export const GEMINI_VOICE_OPTIONS: { value: string; label: string }[] = [
  ['Iapetus', 'Clear'],
  ['Charon', 'Informative'],
  ['Kore', 'Firm'],
  ['Puck', 'Upbeat'],
  ['Aoede', 'Breezy'],
  ['Zephyr', 'Bright'],
  ['Leda', 'Youthful'],
].map(([name, style]) => ({ value: name, label: `${name} — ${style}` }))

// Fixed phrase used for voice previews. Keeping it constant means the synthesis
// is cached after the first preview of each voice (shared across all users), so
// previews don't repeatedly spend Gemini quota or load the server.
export const VOICE_PREVIEW_PHRASE = "Hi — this is a preview of how I'll read replies aloud."

